import { SMSSendService } from '@weave/schema-gen-ts/dist/schemas/sms/send/v3/send_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaSendV3Service = bindHTTP(SMSSendService);
export const serviceName = 'send-v3' as const;
